import React from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";

const Support = ({ handleShow }) => {

  return (
    <div>
      <div
        className="leftContainer mb_space"
        style={{ minHeight: "100vh", height: "100%" }}
      >
      <div className="support-bubble-container">
  {/* Modern Circular Header */}
  <div className="support-center-circle">
    <div className="circle-inner-content">
      <img src='/support.jpg' alt="support" className="support-avatar-main" />
      <div className="online-dot-pulse"></div>
    </div>
    <h2 className="support-text-main">Support Center</h2>
    <p className="support-subtext-main">How would you like to connect?</p>
  </div>

  {/* Floating Action Bubbles */}
  <div className="bubble-actions-wrapper">
    
    {/* WhatsApp Bubble */}
    <a
      className="contact-bubble whatsapp-bubble-style"
      target="_blank"
      href={JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport}
    >
      <div className="bubble-icon-area">
        <img src={process.env.PUBLIC_URL + "/images/whatsapp.png"} alt="WA" />
      </div>
      <div className="bubble-label-area">
        <strong>WhatsApp</strong>
        <span>Live Chat</span>
      </div>
    </a>

    {/* Call Bubble */}
    <a
      className="contact-bubble call-bubble-style"
      target="_blank"
      href={
        "tel:" +
        (JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile || "")
      }
    >
      <div className="bubble-icon-area">
        <img src={process.env.PUBLIC_URL + "/images/phone.png"} alt="Call" />
      </div>
      <div className="bubble-label-area">
        <strong>Mobile</strong>
        <span>Direct Call</span>
      </div>
    </a>

  </div>

  <div className="support-footer-tag">
    <span>Available 24x7 for your help</span>
  </div>
</div>
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );


};

export default Support;
